// PERSONA FRAGRANCE INTELLIGENCE — official uploaded brand assets
// Do NOT redraw, regenerate, reinterpret or restyle these assets.

export const ASSETS = {
  personaLogo:
    "https://customer-assets-agu9un31.emergentagent.net/job_persona-saas-beta/artifacts/rcq2auyg_862178bb-a32d-4bbc-82e5-a63085fc22ed.png",
  twfhLogo:
    "https://customer-assets-agu9un31.emergentagent.net/job_persona-saas-beta/artifacts/ifpkryv6_ChatGPT%20Image%20Sep%2012%2C%202026%2C%2002_38_26%20PM.png",
  iptechsLogo:
    "https://customer-assets-agu9un31.emergentagent.net/job_persona-saas-beta/artifacts/j3l9xyn9_Logo%20IPTECHS.jpg",
  founderPortrait:
    "https://customer-assets-agu9un31.emergentagent.net/job_persona-saas-beta/artifacts/gpvd396c_foto%20TW.png",
};
